import React from 'react';

import {HeatmapInternalPoint, HeatmapPoint} from '../Heatmap';
import {HEATMAP_MASK_CROSS_COLOR, HEATMAP_MASK_FILL_COLOR} from './utils/Theme';

export interface HeatmapBoxProps<DataPoint extends HeatmapPoint> {
  color?: string;
  heatmapInnerBin: HeatmapInternalPoint<DataPoint>;
  height: number;
  width: number;
  x: number;
  y: number;
}

export default function HeatmapBox<DataPoint extends HeatmapPoint>({
  color,
  heatmapInnerBin,
  height,
  width,
  x,
  y,
}: HeatmapBoxProps<DataPoint>): JSX.Element | null {
  const dataPoint = {
    x: heatmapInnerBin.x,
    y: heatmapInnerBin.y,
    isMasked: heatmapInnerBin.isMasked,
    metric: heatmapInnerBin.metric == null ? 'No data' : heatmapInnerBin.metric,
  };

  const maskedCrossWidth = Math.min(width, height) * 0.75;
  const maskedCrossX = Math.max(x, x + (width - maskedCrossWidth) / 2);
  const maskedCrossY = Math.max(y, y + (height - maskedCrossWidth) / 2);

  return (
    <>
      <rect
        fill={dataPoint.isMasked ? HEATMAP_MASK_FILL_COLOR : color}
        height={height}
        width={width}
        x={x}
        y={y}
      />
      {dataPoint.isMasked && (
        <g
          pointerEvents="none"
          style={{
            stroke: `${HEATMAP_MASK_CROSS_COLOR}`,
            strokeLinecap: 'round',
            strokeWidth: maskedCrossWidth / 8,
            transform: `translate(${maskedCrossX}px, ${maskedCrossY}px)`,
          }}
        >
          <line x2={maskedCrossWidth} y2={maskedCrossWidth} />
          <line x1={maskedCrossWidth} y2={maskedCrossWidth} />
        </g>
      )}
    </>
  );
}
